import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalPointsInfoPage } from './modal-points-info.page';

const routes: Routes = [
  {
    path: '',
    component: ModalPointsInfoPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalPointsInfoPageRoutingModule {}
